// Styles
import { IonCol, IonGrid, IonImg, IonList, IonRow, IonText } from '@ionic/react';
import { userInfo } from 'os';

import styles from '@/components/Clients/ModalContent.module.css';
import { Input } from '@/components/Input';
import { CustomLoading } from '@/components/Loading/CustomLoading';

import { mergeClassNames } from '@/utils/mergeClassNames';

type AddClientModalContentProps = {
  clientData: {
    firstName: string;
    lastName: string;
    dateOfBirth: string;
    email: string;
  };
  errors: {
    firstName: string;
    lastName: string;
    email: string;
  };
  onInputChange: (field: string, value: string) => void;
  loading: boolean;
};

export const AddClientModalContent = ({ clientData, errors, onInputChange, loading }: AddClientModalContentProps) => {
  return (
    <>
      <div className={styles.container}>
        {/* 🔥 Overlay that covers the form when loading */}
        {loading && (
          <div className={styles.loadingOverlay}>
            <CustomLoading message='Creating Client...' size='large' />
          </div>
        )}
        <IonGrid className={styles.wrapper}>
          <IonRow
            className='ion-align-items-center ion-justify-content-center ion-margin-vertical'
            style={{ width: '100%' }}>
            <IonCol className='ion-margin-top' size='6'>
              <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
                <Input
                  disabled={loading}
                  hasError={!!errors.firstName}
                  label='Name'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('firstName', e.detail.value!)}
                  placeholder='John'
                  type='text'
                  value={clientData.firstName}
                  variant='light'
                />
                {errors.firstName && (
                  <IonText className={styles.errorText} color='danger'>
                    {errors.firstName}
                  </IonText>
                )}
              </IonList>
            </IonCol>
            <IonCol className='ion-margin-top' size='6'>
              <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
                <Input
                  disabled={loading}
                  hasError={!!errors.lastName}
                  label='Surname'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('lastName', e.detail.value!)}
                  placeholder='Doe'
                  type='text'
                  value={clientData.lastName}
                  variant='light'
                />
                {errors.lastName && (
                  <IonText className={styles.errorText} color='danger'>
                    {errors.lastName}
                  </IonText>
                )}
              </IonList>
            </IonCol>
          </IonRow>
          <IonRow
            className='ion-align-items-center ion-justify-content-center ion-padding-vertical'
            style={{ width: '100%' }}>
            <IonCol className='ion-margin-top' size='12'>
              <IonList class={mergeClassNames(styles['no-padding'], styles.list)} mode='md'>
                <Input
                  disabled={loading}
                  label='Date of birth'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('dateOfBirth', e.detail.value!)}
                  placeholder='00/00/0000'
                  type='date'
                  value={clientData.dateOfBirth}
                  variant='light'
                />
                <br />
                <Input
                  disabled={loading}
                  hasError={!!errors.email}
                  label='Email'
                  labelPlacement='stacked'
                  onIonInput={(e) => onInputChange('email', e.detail.value!)}
                  placeholder='name@mail.com'
                  type='email'
                  value={clientData.email}
                  variant='light'
                />
                {errors.email && (
                  <IonText className={styles.errorText} color='danger'>
                    {errors.email}
                  </IonText>
                )}
              </IonList>
            </IonCol>
          </IonRow>
        </IonGrid>
      </div>
    </>
  );
};
